<template>
  <div>
    <div class="d-flex justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">ติดตามความก้าวหน้า (รายเดือน)</div>
        <div class="d-flex align-center">
          <Iconify
            icon="ion:document-text"
            color="var(--theme-color-one)"
            class="mr-3"
          ></Iconify>
          <div class="txt-head black--text">รายงานผลการดำเนินการ</div>
        </div>
      </div>

<!--      <div class="d-flex flex-column gap-12">-->
<!--        <div class="d-flex gap-12">-->
<!--          <Button @onClick="seeInfo"> รายละเอียดโครงการ </Button>-->
<!--        </div>-->
<!--      </div>-->
    </div>

    <div class="d-flex flex-column gap-16">
      <!--  Info card  -->
      <divcard class="d-flex flex-column gap-8">
        <div class="d-flex gap-8">
          <div
            class="black--text font-type-bold"
            style="min-width: 140px; max-width: 140px"
          >
            แผนงาน
          </div>
          <div>
            {{ info.planName }}
          </div>
        </div>

        <div class="d-flex gap-8">
          <div
            class="black--text font-type-bold"
            style="min-width: 140px; max-width: 140px"
          >
            ชื่อโครงการ(ไทย)
          </div>
          <div>
            {{ info.projectNameTH }}
          </div>
        </div>
      </divcard>

      <!--  Plan card  -->
      <divcard>
        <div class="txt-head black--text mb-3">แผนการดำเนินงานวิจัย</div>

        <!-- TODO 1: remove this -->
       <!-- <div class="d-flex gap-12 mb-n5">
         <div class="pt-2">(DEMO): If today is:</div>
          <DatePicker
              :value="customDateNow"
              @onInput="onChangeDateDemo"
            ></DatePicker>
        </div> -->

        <div class="d-flex justify-space-between align-end">
          <div class="black--text">
            1. แผนการดำเนินงาน (จัดทำในรูปแบบ Project based management)
          </div>
          <div>
            <div class="tiny-field px-2 mb-1">แผน</div>
            <div class="tiny-field px-2">ผล</div>
          </div>
        </div>

        <div class="py-5 overflow-x-auto mx-n6 px-6 scroll">
          <div
            class="d-flex justify-space-between align-center gap-8 px-3 mb-3"
            :key="planTableKey"
          >
            <div class="flex" style="min-width: 30px; max-width: 30px"></div>
            <div class="flex" style="min-width: 120px; max-width: 120px">
              กิจกรรม
            </div>
            <div
              class="flex text-center"
              style="min-width: 61px; max-width: 61px"
            >
              WF
            </div>
            <div
              v-for="(m, ind) in yearBudgetList"
              :key="ind"
              class="flex"
              style="min-width: 43px; max-width: 43px"
            >
           
               
              <div
                class="flex-center"
                style="min-height: 28px; max-height: 28px"
              >
                <v-btn
                  v-if="(isInCorrectRange(m) || (info.extend_progress_time && info.extend_progress_time.length > 0 && info.extend_progress_time.includes(m.yearMonth))) && !(confirm_index && (ind !== confirm_index))"
                  small
                  icon
                  @click="editProgress(ind)"
                >
                  <Iconify
                    icon="material-symbols:edit"
                    color=" var(--theme-color-seven) "
                  ></Iconify>
                </v-btn>
              </div>
              <div class="text-center">{{ m.month_th }}</div>
              <div class="text-center">{{ m.year_th }}</div>
            </div>
            <div class="flex" style="min-width: 43px; max-width: 43px">
              แผนผล
            </div>
            <div
              class="flex text-center"
              style="min-width: 43px; max-width: 43px"
            >
              %
            </div>
          </div>

          <!--   PLAN ITEMS   -->
          <div
            v-if="allPlans && allPlans.length > 0"
            class="d-flex flex-column gap-12"
          >
            <div
              v-for="(item, i) in allPlans"
              :key="i"
              class="plan-card d-flex justify-space-between gap-8"
              :class="{ 'plan-active': tempPlan && tempPlan.temp_index === i }"
            >
              <div class="flex" style="min-width: 30px; max-width: 30px"></div>
              <div
                class="flex two-line"
                style="min-width: 120px; max-width: 120px; max-height: 45px"
              >
                {{ item.activityName }}
              </div>
              <div
                class="flex d-flex justify-space-between"
                style="min-width: 61px; max-width: 61px; height: 54px"
              >
                <v-divider vertical></v-divider>
                <div
                  class="tiny-field tf-active"
                  style="min-width: 40px; max-width: 40px; height: 100%"
                >
                  {{ item.wf }}
                </div>
                <v-divider vertical></v-divider>
              </div>
              <div
                v-for="(m, ind) in item.months"
                :key="ind"
                class="flex d-flex flex-column gap-8"
                :class="{'border-right-field': isInCorrectRange(m)}"
                style="min-width: 43px; max-width: 43px;"
              >
                <div class="tiny-field">
                  {{ m.monthValue ? formatNumber(m.monthValue, 2) : "-" }}
                </div>
                <div class="tiny-field">
                  {{ m.actualMonthValue ? formatNumber(m.actualMonthValue, 2) : "-" }}
                </div>
              </div>
              
              <div
                class="flex d-flex flex-column gap-8"
                style="min-width: 43px; max-width: 43px"
              >
                <div class="tiny-field">
                  {{ formatNumber(item.plan, 2) }}
                </div>
                <div class="tiny-field">
                  {{ formatNumber(item.result, 2) }}
                </div>
              </div>

              <div
                class="flex d-flex flex-column gap-8"
                style="min-width: 43px; max-width: 43px"
              >
                <div class="tiny-field">
                  {{ formatNumber(item.percent, 2) }}
                </div>
                <div class="tiny-field">
                  {{
                    item.plan > 0 ?
                    formatNumber(parseFloat((item.result * 100) / item.plan), 2)
                    : 0
                  }}
                </div>
              </div>
            </div>
            <!--   SUMMARY   -->
            <div class="plan-card">
              <div class="d-flex justify-space-between gap-8">
                <div
                  class="flex"
                  style="min-width: 30px; max-width: 30px"
                ></div>
                <div class="flex" style="min-width: 120px; max-width: 120px">
                  แผนงานถ่วงน้ำหนัก
                </div>
                <div
                  class="flex d-flex justify-space-between"
                  style="min-width: 61px; max-width: 61px"
                >
                  <v-divider vertical></v-divider>
                  <div
                    class="tiny-field"
                    :class="{
                      'theme-color-four tf-error': totalWF() !== '1.00',
                    }"
                    style="min-width: 40px; max-width: 40px"
                  >
                    {{ totalWF() }}
                  </div>
                  <v-divider vertical></v-divider>
                </div>

                <div
                  v-for="(m, ind) in yearBudgetList"
                  :key="ind"
                  class="flex"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div v-if="isInCorrectRange(m)" class="border-right-field">
                    <div class="tiny-field">
                      {{ weightPlan(ind) }}
                    </div>
                  </div>
                  <div v-else>
                    <div class="tiny-field">
                      {{ weightPlan(ind) }}
                    </div>
                  </div>
                </div>

                <div
                  class="flex tiny-field"
                  style="min-width: 43px; max-width: 43px"
                >
                  {{ weightActivePlan() }}
                </div>
                <div
                  class="flex tiny-field"
                  style="min-width: 43px; max-width: 43px"
                >
                  {{ weightActivePlanPercent() }}
                </div>
              </div>

              <v-divider class="my-3"></v-divider>

              <div class="d-flex justify-space-between gap-8">
                <div
                  class="flex"
                  style="min-width: 30px; max-width: 30px"
                ></div>
                <div class="flex" style="min-width: 120px; max-width: 120px">
                  ผลการดำเนินงาน
                </div>
                <div
                  class="flex d-flex justify-space-between"
                  style="min-width: 61px; max-width: 61px"
                >
                  <v-divider vertical></v-divider>
                  <div style="min-width: 40px; max-width: 40px"></div>
                  <v-divider vertical></v-divider>
                </div>
                <div
                  v-for="(m, ind) in yearBudgetList"
                  :key="ind"
                  class="flex"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div v-if="isInCorrectRange(m)" class="border-right-field">
                    <div class="tiny-field">
                      {{ resultPlan(ind) }}
                    </div>
                  </div> 
                  <div v-else>
                    <div class="tiny-field">
                       {{ resultPlan(ind) }}
                    </div>
                  </div>
                </div>
                <div
                  class="flex tiny-field"
                  style="min-width: 43px; max-width: 43px"
                >
                  {{ weightActiveResult() }}
                </div>
                <div
                  class="flex tiny-field"
                  style="min-width: 43px; max-width: 43px"
                >
                  {{
                    weightActivePlan() == 0 ? weightActiveResult() : (weightActivePlan() > 0 ? formatNumber(parseFloat((weightActiveResult() * 100) / weightActivePlan()),2) : 0)
                  }}
                </div>
              </div>

              <v-divider class="my-3"></v-divider>

              <div class="d-flex justify-space-between gap-8">
                <div
                  class="flex"
                  style="min-width: 30px; max-width: 30px"
                ></div>
                <div class="flex" style="min-width: 120px; max-width: 120px">
                  แผนการใช้จ่ายจริง
                </div>
                <div
                  class="flex d-flex justify-space-between"
                  style="min-width: 61px; max-width: 61px"
                >
                  <v-divider vertical></v-divider>
                  <div style="min-width: 40px; max-width: 40px"></div>
                  <v-divider vertical></v-divider>
                </div>
                <div
                  v-for="(m, ind) in yearBudgetList"
                  :key="ind"
                  class="flex"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div v-if="isInCorrectRange(m)" class="border-right-field">
                    <div class="tiny-field">
                      {{ formatNumber(m.planBudgetRate, 2) }}
                    </div>
                  </div> 
                  <div v-else>
                    <div class="tiny-field">
                      {{ formatNumber(m.planBudgetRate, 2) }}
                    </div>
                  </div>   
                </div>
                <div
                  class="flex tiny-field"
                  style="min-width: 43px; max-width: 43px"
                >
                  {{
                    formatNumber(yearBudgetList[currIndex].planBudgetRate, 2)
                  }}
                </div>
                <div
                  class="flex tiny-field"
                  style="min-width: 43px; max-width: 43px"
                >
                  {{
                    yearBudgetList[yearBudgetList.length - 1].planBudgetRate
                      ? yearBudgetList[yearBudgetList.length - 1].planBudgetRate
                      : "-"
                  }}
                </div>
              </div>

              <v-divider class="my-3"></v-divider>

              <div class="d-flex justify-space-between gap-8">
                <div
                  class="flex"
                  style="min-width: 30px; max-width: 30px"
                ></div>
                <div class="flex" style="min-width: 120px; max-width: 120px">
                  การใช้จ่ายจริง
                </div>
                <div
                  class="flex d-flex justify-space-between"
                  style="min-width: 61px; max-width: 61px"
                >
                  <v-divider vertical></v-divider>
                  <div style="min-width: 40px; max-width: 40px"></div>
                  <v-divider vertical></v-divider>
                </div>
                <div
                  v-for="(m, ind) in yearBudgetList"
                  :key="ind"
                  class="flex"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div v-if="isInCorrectRange(m)" class="border-right-field">
                    <div class="tiny-field">
                      {{ formatNumber(m.useBudgetRate, 2) }}
                    </div>
                  </div>
                  <div v-else>
                    <div class="tiny-field">
                      {{ formatNumber(m.useBudgetRate, 2) }}
                    </div>
                  </div>
                </div>
                <div
                  class="flex tiny-field"
                  style="min-width: 43px; max-width: 43px"
                >
                  {{ formatNumber(yearBudgetList[currIndex].useBudgetRate, 2) }}
                </div>
                <div
                  class="flex tiny-field"
                  style="min-width: 43px; max-width: 43px"
                >
                  {{
                    yearBudgetList[currIndex]?.planBudgetRate > 0 ?
                    formatNumber(
                        parseFloat(yearBudgetList[currIndex]?.useBudgetRate * 100) / parseFloat(yearBudgetList[currIndex]?.planBudgetRate)
                        ,
                        2
                    ) : 0
                  }}
                </div>
              </div>
            </div>
          </div>

          <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
        </div>
      </divcard>

      <!--  Editor  -->
      <divcard v-if="editMode" id="edit-card">
        <div class="black--text">ผลการดำเนินงานประจำเดือน</div>
        <div class="black--text d-flex gap-8">
          <div class="first-col-editor">กิจกรรม</div>
          <div class="second-col-editor">WF</div>
        </div>
        <div v-for="(item, i) in allPlans" :key="i" class="d-flex gap-8">
          <div class="first-col-editor pt-2">
            {{ item.activityName }}
          </div>

          <div class="second-col-editor pt-2">
            {{ item.wf }}
          </div>

          <TextField
            theme="3"
            input-type="number"
            style="min-width: 200px; max-width: 200px"
            :value="dataEditMode[i]"
            @onChange="setResultValue(i, $event)"
          ></TextField>
          <!-- <TextField
            theme="3"
            input-type="number"
            style="min-width: 200px; max-width: 200px"
            :value="tempPlan[item.months[tmpindex].id]"
            @onChange="setResultValue(item.months[tmpindex].id, $event)"
          ></TextField> -->
        </div>

        <v-divider class="my-3"></v-divider>

        <div class="black--text">การใช้จ่ายจริง</div>
        <div class="d-flex gap-8">
          <div class="first-col-editor pt-2">การใช้จ่ายจริง (บาท)</div>

          <div class="second-col-editor"></div>

          <TextField
            theme="3"
            input-type="decimal"
            style="min-width: 200px; max-width: 200px"
            :value="useBudget"
            @onChange="useBudget = $event"
          ></TextField>
        </div>

        <div class="d-flex justify-end">
          <Button
            min-width="80px"
            theme="2"
            class="mr-3"
            @onClick="editMode = false"
            >ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="confirmEdit"
            >ยืนยัน
          </Button>
        </div>
      </divcard>

      <div class="d-flex justify-space-between">
        <Button theme="2" @onClick="onCancel">ยกเลิก</Button>

        <div class="flex-center">
          <Button min-width="120px" @onClick="onSave">บันทึก</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../../components/input/Button";
import TextField from "../../components/input/TextField";
import DatePicker from "../../components/input/DatePicker";
import { format } from "date-fns";
import { th } from "date-fns/locale";
import { formatNumber } from "@/plugins/global-funcs";
import {mapState} from "vuex";

export default {
  name: "MonthlyProgressForm",
  components: {
    Button,
    TextField,
    DatePicker,
  },
  data() {
    return {
      confirm_index: undefined,
      formatNumber,
      info: {},
      editMode: false,
      tempPlan: {},
      allPlans: [],
      yearBudgetList: [],
      useBudget: undefined,
      useBudgetSum: undefined,
      tmpindex: undefined,
      customDateNow: undefined,
      planTableKey: 0,
      currIndex: null,
      dataEditMode: [],
    };
  },
  computed: {
    ...mapState({
      isRSP: (state) => state.Auth.User.user_type === "RSP",
    }),
  },
  created() {
    if (!this.$route.query.id) this.onCancel();
    this.getMasterData();
  },
  methods: {
    seeInfo() {},
    getCurrIndex() {
      let ind = 0;
      for (const x of this.allPlans) {
        let i = 0;
        for (const y of x.months) {
          let correctIndex = this.isInCorrectRange(y, i);
          if (typeof correctIndex !== "boolean") return correctIndex;
          i++;
        }
        ind++;
      }
    },
    isInCorrectRange(item, index = null) {
      let today = new Date();
      // if (this.customDateNow) today = new Date(this.customDateNow); // TODO 2: remove this line

      let currentMonth = today.getMonth();

      let thisMonth = new Date(item.yearMonth).getMonth();
      let thisYear = new Date(item.yearMonth).getFullYear();

      let isCorrectCase =
          ((today.getDate() >= 5 && thisMonth === currentMonth) || (today.getDate() <= 4 && thisMonth === currentMonth - 1))
      && today.getFullYear() === thisYear;

      // for return active yearMonth index
      if (isCorrectCase && index !== null) return index;

      return isCorrectCase;
    },
    async getMasterData() {
      let res = await this.$apiFire(
        "MonthlyProgress/getPlanForEdit",
          {
            id: this.$route.query.id,
            form_type: this.$route.query.form_type,
          }
      );
      console.log(res);
      if (res) {
        this.info = res;

        this.yearBudgetList = res.expenseList.map((x) => ({
          ...x,
          month_th: format(new Date(x.yearMonth), "MMM", { locale: th }), // to TH short month
          year_th: (parseInt(x.yearMonth.split("-")[0]) + 543)
            .toString()
            .slice(2), // last 2 letters of year string
        }));
        this.allPlans = res.p1List;
        let ind = 0;
        for (const x of this.allPlans) {
          x.percent = this.getLastProgress(x.months);
          let i = 0;
          for (const y of x.months) {
            let correctIndex = this.isInCorrectRange(y, i);
            if (typeof correctIndex !== "boolean") {
              x.plan = this.allPlans[ind].months[correctIndex].monthValue;
              x.result = this.allPlans[ind].months[correctIndex].actualMonthValue;
            }
            i++;
          }
          ind++;
        }
        this.currIndex = this.getCurrIndex() || 0;
      } else {
        this.onCancel();
      }
    },
    onCancel() {
      if(this.isRSP) {
        this.$router.push({ name: "RSPMonthlyProgressList" });
      } else {
        this.$router.push({name: "MonthlyProgressList"});
      }
    },
    async onSave() {
      let yearMonth;
      let editList = [];
      let i = 0;
      for (const x of this.yearBudgetList) {
        if (this.confirm_index === i) {
          yearMonth = x.yearMonth;
        } 
        i++;
      }
      for (const x of this.allPlans) {
        for (const y of x.months) {
          if (yearMonth == y.yearMonth) {
            editList.push({
              id: y.id,
              actualMonthValue: y.actualMonthValue,
            });
          }
        }
      }
      let payload = {
        yearMonth,
        p1List: editList,
        useBudget: this.useBudget,
        useBudgetSum: this.useBudgetSum,
        useBudgetRate: this.useBudgetRate,
        actualMonthValue: this.actualMonthValue,
        formType: this.$route.query.form_type,
      };

      let res = await this.$apiFire("MonthlyProgress/updatePlan", {
        id: this.$route.query.id,
        data: payload,
      });
      if (res) {
        if(this.isRSP) {
          await this.$router.push({ name: "RSPMonthlyProgressList" });
        } else {
          await this.$router.push({name: "MonthlyProgressList"});
        }
      }
    },
    editProgress(index) {

      // clear
      this.useBudget = undefined;
      // for (const x of this.allPlans) {
      //   console.log(
      //     "x.months[index].actualMonthValue",
      //     x.months[index].actualMonthValue
      //   );
      //   // if months ตั้งแต่ตัวที่ index ถึงสุดท้าย
      //   if (x.months[index].actualMonthValue) {
      //     this.tempPlan[x.months[index].id] = x.months[index].actualMonthValue;
      //   } else {
      //     this.tempPlan[x.months[index].id] = x.months[index].month_value;
      //   }
      // }

      this.allPlans.forEach((item, i) => {
        // loop ตั้งแต่ตัวที่ index ถึงสุดท้าย
        // for (let j = index; j < item.months.length; j++) {
          if (item.months[index].actualMonthValue) {
            this.dataEditMode[i] = item.months[index].actualMonthValue;
          } else {
            this.dataEditMode[i] = item.months[index].month_value;
          }
        // }
      });


      if (!this.useBudget) {
        if(this.yearBudgetList[index].useBudget > 0) {
          console.log('use');
          this.useBudget = this.yearBudgetList[index].useBudget;
        }
        else
        {
          console.log('plan')
          this.useBudget = this.yearBudgetList[index].planBudget;
        }
      }
      console.log(this.yearBudgetList[index]);
      this.tmpindex = index;
      this.editMode = true;

      this.$nextTick(() => {
        this.$vuetify.goTo("#edit-card");
      });
    },
    confirmEdit() {
      this.dataEditMode.forEach((item, i) => {
        // loop allPlans เพื่อ set ค่าตัวที่ index ถึงตัวสุดท้าย
        for (let j = this.tmpindex; j < this.allPlans[i].months.length; j++) {
          this.allPlans[i].months[j].actualMonthValue = item;
        }
      });

      this.editMode = false;
      let planBudget = parseFloat(this.yearBudgetList[this.tmpindex].planBudget);
      if(this.tmpindex > 0) {
        this.useBudgetSum = parseFloat(this.yearBudgetList[this.tmpindex - 1].useBudgetSum) + parseFloat(this.useBudget);
      }else{
        this.useBudgetSum = this.useBudget
      }

      console.log('useBudgetSum',this.useBudgetSum)
      console.log('useBudget', this.useBudget)
      console.log('planBudget', planBudget)
      if (this.useBudget != 0 && planBudget != 0) {
        console.log('is in')
        this.useBudgetRate = ((parseFloat(this.useBudget) / parseFloat(this.yearBudgetList[this.tmpindex].planBudget)) * 100).toFixed(2);
      }
      else this.useBudgetRate = 0.0;

      console.log('budgetRate', this.useBudgetRate)
      this.yearBudgetList[this.tmpindex].useBudgetRate = this.useBudgetRate;
      this.yearBudgetList[this.tmpindex].useBudget = this.useBudget;
      console.log('yearBudgetList',this.yearBudgetList)
      this.actualMonthValue = this.resultPlan(this.tmpindex);

      this.confirm_index = this.tmpindex

      this.$forceUpdate();

      // clear temp
      this.tempPlan = {};
      
    },
    totalWF() {
      if (!this.allPlans || this.allPlans.length === 0) return "-";
      let total = this.allPlans
        .map((x) => x.wf)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    weightPlan(index) {
      let total = [];
      for (const x of this.allPlans) {
        let result = parseFloat(x.months[index].monthValue * x.wf);
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0);
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    resultPlan(index) {
      let total = [];
      for (const x of this.allPlans) {
        let result = parseFloat(x.months[index].actualMonthValue * x.wf);
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0);
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    weightActivePlan() {
      return this.weightPlan(this.currIndex);
      // let ind = 0
      // for (const x of this.allPlans) {
      //   let i = 0
      //   for (const y of x.months) {
      //     let correctIndex = this.isInCorrectRange(y, i)
      //     if (typeof correctIndex !== 'boolean') return this.weightPlan(correctIndex)
      //     i++
      //   }
      //   ind++
      // }
    },
    weightActiveResult() {
      return this.resultPlan(this.currIndex);
      // let ind = 0
      // for (const x of this.allPlans) {
      //   let i = 0
      //   for (const y of x.months) {
      //     let correctIndex = this.isInCorrectRange(y, i)
      //     if (typeof correctIndex !== 'boolean') return this.resultPlan(correctIndex)
      //     i++
      //   }
      //   ind++
      // }
    },
    weightActivePlanPercent() {
      let all = [];
      for (let i = 0; i < this.yearBudgetList.length; i++) {
        all.push(this.weightPlan(i));
      }

      if (all.length > 0) {
        for (const x of all.reverse()) {
          if (!!x && x !== "-") {
            return x;
          }
        }
      }
      return "-";
    },
    getLastProgress(items) {
      items = this.removeVModel(items);
      if (items && typeof items === "object" && items.length > 0) {
        for (const x of items.reverse()) {
          if (!!x.monthValue && x.monthValue !== "-") {
            return x.monthValue;
          }
        }
      }
      return "-";
    },
    removeVModel(item) {
      return JSON.parse(JSON.stringify(item));
    },
    setResultValue(id, val) {
      this.dataEditMode[id] = val;
      // this.tempPlan[id] = val;

      this.$forceUpdate();
    },
    // onChangeDateDemo(val) {
    //   console.log("valDemo",val)
    //   this.customDateNow = val;
    //   this.currIndex = this.getCurrIndex();
    //   console.log("currIndex", this.currIndex);
    //   this.$forceUpdate();
    //   this.planTableKey++;
    // },
  },
};
</script>

<style scoped lang="scss">
* {
  --editor-first-col-width: 320px;
  --editor-second-col-width: 60px;
}

.first-col-editor {
  min-width: var(--editor-first-col-width);
  max-width: var(--editor-first-col-width);
}
.second-col-editor {
  min-width: var(--editor-second-col-width);
  max-width: var(--editor-second-col-width);
}

.plan-card {
  background: #ffffff;
  box-shadow: 1px 1px 18px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  border: 1px solid transparent;
  padding: 12px;
  min-width: max-content;
  &.plan-active {
    border: 1px solid var(--theme-color-seven);
  }
}

.border-right-field{
  border-right: 3px solid var(--theme-color-seven);
}
</style>
